const NOT_AVAILABLE = '-'
const DELIVERY_TIME_UNIT = 'дн.'

export const IN_STOCK_DELIVERY_LABEL = 'На складе'

export function formatDeliveryTime(
  minDays: number | null | undefined,
  maxDays: number | null | undefined
): string {
  if (minDays == null || maxDays == null) return NOT_AVAILABLE
  if (minDays === 0 && maxDays === 0) return IN_STOCK_DELIVERY_LABEL
  if (minDays === maxDays) return `${minDays} ${DELIVERY_TIME_UNIT}`
  return `${minDays}-${maxDays} ${DELIVERY_TIME_UNIT}`
}
